import { getCloudFunctionUrl } from "../firebase";

const CREATE_STUDENT_ACCOUNT_URL = getCloudFunctionUrl("createStudentAccount");
const PENDING_CREATIONS_KEY = "enrollease.pendingAccountCreations.v1";

function creationKey({ caller, email, studentDocumentId, staffProfile }) {
  return [
    caller.uid,
    email.trim().toLowerCase(),
    studentDocumentId || staffProfile?.role || "staff"
  ].join(":");
}

function getOrCreateOperationId(key) {
  const pending = JSON.parse(window.localStorage.getItem(PENDING_CREATIONS_KEY) || "{}");
  let operationId = pending[key];
  if (typeof operationId !== "string" || !/^[a-f0-9-]{20,80}$/i.test(operationId)) {
    operationId = window.crypto?.randomUUID?.();
    if (!operationId) throw new Error("Secure account-creation request IDs are unavailable.");
    pending[key] = operationId;
    window.localStorage.setItem(PENDING_CREATIONS_KEY, JSON.stringify(pending));
  }
  return operationId;
}

function clearOperationId(key) {
  const pending = JSON.parse(window.localStorage.getItem(PENDING_CREATIONS_KEY) || "{}");
  delete pending[key];
  window.localStorage.setItem(PENDING_CREATIONS_KEY, JSON.stringify(pending));
}

export async function createManagedAccount({
  caller,
  email,
  displayName,
  password,
  studentDocumentId,
  idNumber,
  staffProfile
}) {
  if (!caller) {
    throw new Error("Your session has expired. Sign in again before approving this student.");
  }
  if (typeof email !== "string" || !email.trim()) {
    throw new Error("A valid account email is required.");
  }

  const key = creationKey({ caller, email, studentDocumentId, staffProfile });
  const operationId = getOrCreateOperationId(key);
  const token = await caller.getIdToken(true);
  const response = await fetch(CREATE_STUDENT_ACCOUNT_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      operationId,
      email,
      displayName,
      password,
      studentDocumentId,
      idNumber,
      staffProfile
    })
  });
  const result = await response.json().catch(() => null);
  if (!response.ok || typeof result?.uid !== "string" || !result.uid) {
    if (result?.error?.code === "creation_failed") clearOperationId(key);
    const error = new Error(
      result?.error?.message || "The account could not be created."
    );
    error.code = result?.error?.code || "account_creation_failed";
    throw error;
  }
  clearOperationId(key);
  return result;
}
